import type { IncidentType, IncidentStatus } from "./types";

export const INCIDENT_TYPE_CONFIG: Record<IncidentType, {
    label: string;
    icon: string;
    color: string;
    bgColor: string;
    borderColor: string;
    textColor: string;
    priority: number;
}> = {
    critical: {
        label: 'Критический',
        icon: 'alert-circle',
        color: '#EF4444',
        bgColor: 'rgba(239, 68, 68, 0.10)',
        borderColor: 'rgba(239, 68, 68, 0.20)',
        textColor: '#DC2626',
        priority: 1
    },
    warning: {
        label: 'Предупреждение',
        icon: 'alert-triangle',
        color: '#F59E0B',
        bgColor: 'rgba(245, 158, 11, 0.10)',
        borderColor: 'rgba(245, 158, 11, 0.20)',
        textColor: '#D97706',
        priority: 2
    },
    resolved: {
        label: 'Устранён',
        icon: 'check-circle',
        color: '#10B981',
        bgColor: 'rgba(16, 185, 129, 0.10)',
        borderColor: 'rgba(16, 185, 129, 0.20)',
        textColor: '#059669',
        priority: 3
    },
    info: {
        label: 'Информация',
        icon: 'info',
        color: '#3B82F6',
        bgColor: 'rgba(59, 130, 246, 0.10)',
        borderColor: 'rgba(59, 130, 246, 0.20)',
        textColor: '#2563EB',
        priority: 4
    }
};

export const INCIDENT_STATUS_CONFIG: Record<IncidentStatus, {
    label: string;
    color: string;
    bgColor: string;
}> = {
    active: {
        label: 'Активен',
        color: '#EF4444',
        bgColor: 'rgba(239, 68, 68, 0.10)'
    },
    investigating: {
        label: 'Расследуется',
        color: '#F59E0B',
        bgColor: 'rgba(245, 158, 11, 0.10)'
    },
    resolved: {
        label: 'Устранён',
        color: '#10B981',
        bgColor: 'rgba(16, 185, 129, 0.10)'
    },
    archived: {
        label: 'Архивирован',
        color: '#6B7280',
        bgColor: 'rgba(107, 114, 128, 0.10)'
    }
};

export const ANIMATION_VARIANTS = {
    container: {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.05,
                delayChildren: 0.1
            }
        }
    },
    item: {
        hidden: { opacity: 0, y: 20, scale: 0.95 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                type: 'spring',
                stiffness: 100,
                damping: 15
            }
        },
        exit: {
            opacity: 0,
            x: -20,
            transition: { duration: 0.2 }
        }
    },
    details: {
        hidden: { opacity: 0, height: 0 },
        visible: {
            opacity: 1,
            height: 'auto',
            transition: {
                height: { type: 'spring', stiffness: 300, damping: 30 },
                opacity: { duration: 0.2 }
            }
        },
        exit: {
            opacity: 0,
            height: 0,
            transition: {
                height: { duration: 0.2 },
                opacity: { duration: 0.1 }
            }
        }
    }
};

export const REFRESH_INTERVAL = 30000;
export const WEBSOCKET_RECONNECT_DELAY = 5000;